import { Checkbox } from 'antd'
import PropTypes from 'prop-types'
import { Text } from '@qonsoll/react-design'
import { useGetStores } from 'domains/Store/hooks'
import { useSubfilterActions } from 'hooks'
import { useTranslations } from 'contexts/Translation'

const StoreFilter = ({ filterData, setFilterData }) => {
  const [rewardStores] = useGetStores()
  const { t } = useTranslations()

  const { onToggleDetails, onChange, checkIsEnabled } = useSubfilterActions({
    filterData,
    setFilterData,
    fieldName: 'storeId',
    operand: '==',
    type: 'rewardStore'
  })

  return (
    <details
      open={
        localStorage.getItem(`rewardStore-details-visibility`) === 'opened'
      }>
      <summary onClick={onToggleDetails}>{t('Store')}</summary>
      {rewardStores?.map((rewardStore, index) => (
        <Checkbox
          key={`status-${index}`}
          checked={checkIsEnabled(rewardStore)}
          onChange={() => onChange(rewardStore)}>
          <Text wordBreak="break-all">
            {rewardStore?.name || t('Unnamed filter')}
          </Text>
        </Checkbox>
      ))}
    </details>
  )
}

StoreFilter.propTypes = {
  filterData: PropTypes.object,
  setFilterData: PropTypes.func
}

export default StoreFilter
